<template>

    <v-container fluid fill-height>
        <v-layout>

            <v-flex>

                <v-card>

                    <v-breadcrumbs divider="/">
                        <v-breadcrumbs-item to="/" :disabled="false">Početna</v-breadcrumbs-item>
                        <v-breadcrumbs-item to="/families" :exact="true" :disabled="false">Porodice</v-breadcrumbs-item>
                        <v-breadcrumbs-item :disabled="true">Kreiranje</v-breadcrumbs-item>
                    </v-breadcrumbs>

                </v-card>

                <v-card class="fix-card">
                    <form>

                        <v-text-field
                                v-model="family.title"
                                :error="error_messages.title == false"
                                :error-messages="error_messages.title"
                                label="Ime"
                                required
                        ></v-text-field>

                        <v-text-field
                                v-model="family.budget_dinars"
                                :error="error_messages.budget_dinars == false"
                                :error-messages="error_messages.budget_dinars"
                                label="Početni kapital (dinari)"
                                required
                        ></v-text-field>

                        <v-text-field
                                v-model="family.budget_euros"
                                :error="error_messages.budget_euros == false"
                                :error-messages="error_messages.budget_euros"
                                label="Početni kapital (evri)"
                                required
                        ></v-text-field>

                        <v-text-field
                                v-model="family.dinars"
                                :error="error_messages.dinars == false"
                                :error-messages="error_messages.dinars"
                                label="Trenutni kapital (dinari)"
                                required
                        ></v-text-field>

                        <v-text-field
                                v-model="family.euros"
                                :error="error_messages.euros == false"
                                :error-messages="error_messages.euros"
                                label="Trenutni kapital (evri)"
                                required
                        ></v-text-field>

                        <v-checkbox
                                label="Vidljivo"
                                v-model="family.is_visible"
                                color="primary"
                        ></v-checkbox>

                        <v-btn @click="submit()" color="primary">Potvrdi</v-btn>
                        <v-btn @click="clear()" color="secondary" class="black--text">Očisti</v-btn>

                    </form>
                </v-card>

            </v-flex>

        </v-layout>

    </v-container>

</template>

<script>
    import swal from 'sweetalert2';

    export default {
        data() {
            return {
                fillable: ['title', 'slug', 'budget_dinars', 'budget_euros', 'dinars', 'euros', 'is_visible',],
                family: {},
                error_messages: [],
            }
        },
        computed: {
            userProfile(){
                return this.$store.getters['user/getUser'];
            },
        },
        methods: {
            submit(){
                let data = fillForm(this.fillable, this.family);
                axios.post('families', data)
                    .then( res => {
                        swal({
                            position: 'center',
                            type: 'success',
                            title: 'Uspeh',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        this.$router.push('/families');
                    })
                    .catch( e => {
                        this.error_messages = e.response.data;
                    });
            },
            clear(){
                this.user.title = '';
                this.user.budget_dinars = '';
                this.user.budget_euros = '';
                this.user.dinars = '';
                this.user.euros = '';
                this.user.block = false;
                this.error_messages = [];
            },
        }
    }
</script>

<style>
    .navbar-laravel {
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
    }

    .fix-card{
        padding: 20px;
        margin-top: 20px;
    }

    .m-20{
        margin-top: 20px;
    }
</style>
